import * as Yup from 'yup';

export default Yup.object().shape({
  distributorProfile: Yup.object()
    .typeError('SCHEMA_ERRORS.REQUIRED_FIELD')
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
});
